import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import InputBorderModal from "../Forms/Inputs/InputBorderModal";

import * as Yup from "yup";
import "./FormSpecialAddCourse.scss";
import { arrayMerge } from "../../helper/selectDefaultValues";
import SelectOptionSingle from "../Forms/Inputs/SelectOptionSingle";
import {
  getDateAfter,
  getDateBefore,
  getToday,
} from "../../helper/dateConvertor";
import { useState, useEffect } from "react";
import { addCoursesToProposal } from "../../actions/proposal";

const FormSpecialAddCourse = ({ course }) => {
  const toDay = getToday(); // Tiene este formato "2022-10-05"
  const [details, setDetails] = useState(true);
  const [info] = useState({
    duration: course.duration,
    startDate: toDay,
    endDate: "",
  });

  useEffect(() => {
    setDetails(!details);
    //eslint-disable-next-line
  }, []);

  const { coursesSelected } = useSelector((state) => state.proposals);
  const coursesFlat = coursesSelected.map((course) => course._id);
  const { campus } = course;
  const campusDefault = arrayMerge(campus);

  const dispatch = useDispatch();

  const initialValues = {
    duration: course.duration,
    campus: "",
    startDate: "" || toDay, // El Formulario recibe este formato "2022-10-05"
    endDate: "" || info.endDate, // El Formulario recibe este formato "2022-10-05"
    tuitionfee: course.tuitionfee,
    applicationfee: course.applicationfee,
    material: course.material,
    firstPayment: "",
    dateFirstPayment: "",
  };
  const dateAfter = getDateAfter(26);
  const dateDayBefore = getDateBefore(0.15);
  const dateSixAfter = getDateAfter();

  const courseSchema = Yup.object().shape({
    duration: Yup.number()
      .required("Duration Required")
      .min(1, "Invalid Number"),
    campus: Yup.string().required("Campus Required"),
    startDate: Yup.date()
      .required("Date Required")
      .min(dateDayBefore, "Date must be later")
      .max(dateSixAfter, "Date must be earlier"),
    endDate: Yup.date()
      .required("Date Required")
      .min(dateDayBefore, "Date must be later")
      .max(dateSixAfter, "Date must be earlier"),
    tuitionfee: Yup.number()
      .required("Tuition Required")
      .min(0, "Invalid Number"),

    applicationfee: Yup.number()
      .required("Application Required")
      .min(0, "Invalid Number"),

    material: Yup.number()
      .required("Material Required")
      .min(0, "Invalid Number"),
    firstPayment: Yup.number()
      .required("Payment Required")
      .min(0, "Invalid Number"),
    dateFirstPayment: Yup.date()
      .required("Date Required")
      .max(dateAfter, "Date must be earlier")
      .min(new Date(), "Date must be later"),
  });

  const handleFormikSubmit = (values, actions) => {
    // const {tuitionfee, applicationfee, material} = values

    const total = {
      total: values.tuitionfee + values.applicationfee + values.material, // no los initial values
    };

    const courseToProposal = {
      ...course,
      ...values,
      ...total,
    };

    // console.log(values);
    // console.log(courseToProposal);
    dispatch(addCoursesToProposal(courseToProposal));
  };

  const handleOnchange = (e) => {
    // console.log(e.target.name,e.target.value) //<-sirve
    // console.log(e.target) //<-sirve

    if (e.target.name === "duration") {
      // console.log("DURATION", dateEnd)
      // setInfo({...info, endDate: dateEnd})
    }

    // setInfo({
    //   ...info,
    //   [e.target.name] : e.target.value
    // })
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={courseSchema}
      enableReinitialize
      onSubmit={handleFormikSubmit}
    >
      {({ values }) => {
        // console.log(values) // aca me lee los cambios

        return (
          <div className="course-add-form">
            <div className="dot-container title-gray-bold-16">
              <div
                className={`dots-course ${!details && "active-underline"}`}
                type="button"
                onClick={() => setDetails(false)}
              >
                Prices
              </div>
              <div
                className={`dots-course ${details && "active-underline"}`}
                type="button"
                onClick={() => setDetails(true)}
              >
                Details
              </div>
            </div>
            <Form onChange={handleOnchange}>
              <div className="course-add-information">
                {details ? (
                  <div className="col-2">
                    <InputBorderModal
                      name="duration"
                      type="number"
                      label={`Duration(weeks)`}
                    />
                    <SelectOptionSingle
                      label={`Campus`}
                      name={`campus`}
                      options={campusDefault}
                    />
                    <InputBorderModal
                      name="startDate"
                      type="date"
                      label={`Start Date`}
                    />

                    <InputBorderModal
                      name="endDate"
                      type="date"
                      label={`End Date`}
                    />
                  </div>
                ) : (
                  <div className="col-1">
                    <InputBorderModal
                      name="tuitionfee"
                      type="number"
                      label={`Tuition fee`}
                    />
                    <InputBorderModal
                      name="applicationfee"
                      type="number"
                      label={`Application fee`}
                    />
                    <InputBorderModal
                      name="material"
                      type="number"
                      label={`Material`}
                    />
                    <InputBorderModal
                      name="firstPayment"
                      type="number"
                      label={`First Payment`}
                    />
                    <InputBorderModal
                      name="dateFirstPayment"
                      type="date"
                      label={`Date First Payment`}
                    />
                  </div>
                )}
              </div>
              <div className="course-select-item__icons">
                {coursesFlat.includes(course._id) ? (
                  <div className="btn-disable">added</div>
                ) : (
                  <button className="btn-primary" type="submit">
                    + add
                  </button>
                )}
              </div>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};

export default FormSpecialAddCourse;
